import styled from "styled-components";

export const MainModal = styled("div")`
  position: fixed;
  z-index: 9999;
  padding-top: 65px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(66, 65, 65, 0.9);
  overflow: hidden;
`;

export const ModalContent = styled("div")`
  background-color: #f2f2f2;
  margin: auto;
  padding: 5px;
  width: fit-content;
  min-height: 250px;
  border-radius: 7px;
`;

export const HeaderModal = styled("div")`
  display: flex;
  flex-flow: wrap;
  width: 100%;
  position: relative;
  margin: 0px 0px 15px 0px;
  position: absolute;
  left: 50px;
  top: 10px;
`;

export const CloseModal = styled("div")`
  color: white;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
